import { FloatingFormItem } from '@/components/_common';
import GroupsInfiniteSelectField from '@/components/_common/GroupsInfiniteSelectField';
import ManufacturerInfiniteSelectField from '@/components/_common/ManufacturerInfiniteSelectField';
import SubGroupsSelectField from '@/components/_common/SubGroupsSelectField';
import { QuestConsolidatedFilterBy } from '@/core/domain/questReport/Reports/Consolidated/Consolidated.types';
import { Col, Form, Input, Row } from 'antd';
import { useIntl } from 'react-intl';

const ConsolidatedFieldsByFilter: React.FC = () => {
  const intl = useIntl();

  function fieldsToAndFrom() {
    return (
      <>
        <Row gutter={24}>
          <Col lg={6} span={24} md={12}>
            <FloatingFormItem
              name="from"
              label={intl.formatMessage({
                id: 'consolidatedReportStock.form.filterByFrom',
              })}
            >
              <Input />
            </FloatingFormItem>
          </Col>

          <Col lg={6} span={24} md={12}>
            <FloatingFormItem
              name="to"
              label={intl.formatMessage({
                id: 'consolidatedReportStock.form.filterByTo',
              })}
            >
              <Input />
            </FloatingFormItem>
          </Col>
        </Row>
      </>
    );
  }
  return (
    <>
      <Form.Item shouldUpdate noStyle>
        {({ getFieldValue }) => {
          const filterBy = getFieldValue('filterBy');

          switch (filterBy) {
            case QuestConsolidatedFilterBy.manufacturer:
              return (
                <Row>
                  <Col lg={12}>
                    <FloatingFormItem
                      name="filterByIds"
                      label={intl.formatMessage({
                        id: 'directSale.modal.form.manufacturer',
                      })}
                    >
                      <ManufacturerInfiniteSelectField mode="multiple" />
                    </FloatingFormItem>
                  </Col>
                </Row>
              );
            case QuestConsolidatedFilterBy.group:
              return (
                <Row>
                  <Col lg={12}>
                    <FloatingFormItem
                      name="filterByIds"
                      label={intl.formatMessage({
                        id: 'consolidatedReportStock.form.group',
                      })}
                    >
                      <GroupsInfiniteSelectField mode="multiple" onlyGroups />
                    </FloatingFormItem>
                  </Col>
                </Row>
              );

            case QuestConsolidatedFilterBy.subGroup:
              return (
                <Row>
                  <Col lg={12}>
                    <FloatingFormItem
                      name="filterByIds"
                      label={intl.formatMessage({
                        id: 'consolidatedReportStock.form.subGroup',
                      })}
                    >
                      <SubGroupsSelectField mode="multiple" />
                    </FloatingFormItem>
                  </Col>
                </Row>
              );

            default:
              return fieldsToAndFrom();
          }
        }}
      </Form.Item>
    </>
  );
};

export default ConsolidatedFieldsByFilter;
